var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7501 14.4398C16.7501 14.2498 16.8201 14.0598 16.9701 13.9098L19.0001 11.8798L16.9701 9.84977C16.6801 9.55977 16.6801 9.07977 16.9701 8.78977C17.2601 8.49977 17.7401 8.49977 18.0301 8.78977L20.5901 11.3498C20.8801 11.6398 20.8801 12.1198 20.5901 12.4098L18.0301 14.9698C17.7401 15.2598 17.2601 15.2598 16.9701 14.9698C16.8201 14.8198 16.7501 14.6298 16.7501 14.4398Z",
    fill: "#F04438"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07023 11.8799C9.07023 11.4699 9.41023 11.1299 9.82023 11.1299L19.9902 11.1299C20.4002 11.1299 20.7402 11.4699 20.7402 11.8799C20.7402 12.2899 20.4002 12.6299 19.9902 12.6299L9.82023 12.6299C9.40023 12.6299 9.07023 12.2899 9.07023 11.8799Z",
    fill: "#F04438"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 12C3.25 6.85 6.85 3.25 12 3.25C12.41 3.25 12.75 3.59 12.75 4C12.75 4.41 12.41 4.75 12 4.75C7.73 4.75 4.75 7.73 4.75 12C4.75 16.27 7.73 19.25 12 19.25C12.41 19.25 12.75 19.59 12.75 20C12.75 20.41 12.41 20.75 12 20.75C6.85 20.75 3.25 17.15 3.25 12Z",
    fill: "#F04438"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.9063a8c182657d3e34c38a41f6b0cfa5.svg";
export { ForwardRef as ReactComponent };